import { signalSourceMap } from "app/pages/sales-intelligence/domain/signals/types/signal";
import { ScoringConfigType } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

export const getScoringConfigSignalSource = (scope: ScoringConfigType) =>
    scope === ScoringConfigType.Account ? signalSourceMap.account : signalSourceMap.platform;
